var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_18345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7579 21.7504C20.1386 21.7504 21.2579 20.6311 21.2579 19.2504C21.2579 17.8697 20.1386 16.7504 18.7579 16.7504C17.3772 16.7504 16.2579 17.8697 16.2579 19.2504C16.2579 20.6311 17.3772 21.7504 18.7579 21.7504Z",
    stroke: "#0561FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75793 21.7504C7.13865 21.7504 8.25793 20.6311 8.25793 19.2504C8.25793 17.8697 7.13865 16.7504 5.75793 16.7504C4.37722 16.7504 3.25793 17.8697 3.25793 19.2504C3.25793 20.6311 4.37722 21.7504 5.75793 21.7504Z",
    stroke: "#0561FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2579 8.75037H20.2579L23.2579 11.7504V16.7504H16.2579V8.75037Z",
    stroke: "#0561FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2579 3.75037H1.25793V16.7504H16.2579V3.75037Z",
    stroke: "#0561FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_18345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.257935 0.750366)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTruck);
export default __webpack_public_path__ + "static/media/fi_truck.e5591042ee432131304333e6274f6268.svg";
export { ForwardRef as ReactComponent };